import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_GENERAL } from "@/data/products";

export default function StickyCTA() {
  return (
    <motion.div
      initial={{ y: 80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-0 inset-x-0 z-40 md:hidden p-3 bg-[#04070D]/85 backdrop-blur-xl border-t border-[#1A2235]"
    >
      <a href={WA_GENERAL} target="_blank" rel="noopener noreferrer" data-testid="sticky-quote-button"
        className="flex items-center justify-center gap-2 w-full bg-[#25D366] active:bg-[#1eb856] text-white font-semibold py-3.5 rounded-sm text-sm">
        <MessageCircle size={18} /> Cotizar ahora por WhatsApp
      </a>
    </motion.div>
  );
}
